/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Image = styled.img({
  width: `${gridSize() * 20}px`,
});

export const Description = styled.div({
  marginTop: token('space.150'),
});

export const LearnMoreButton = styled(Button)({
  marginTop: token('space.300'),
});

export const OpenJiraButton = styled(Button)({
  marginTop: token('space.300'),
});
